import { ResponseError } from "@freightsimple/generated-dashboard-openapi-client/runtime";

/** True when the API answered 401. useSessionExpiry owns that case (it checks
 *  the session and sends the customer to sign in), so a background fetch that
 *  gets one has nothing left to do. */
export function isUnauthorizedError(error: unknown): boolean {
  return error instanceof ResponseError && error.response.status === 401;
}
